var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "match-item" }, [
    _c("div", { staticClass: "match-wrap" }, [
      _c("div", {
        staticClass: "match-date",
        domProps: { innerHTML: _vm._s(_vm.getDateTimeString(_vm.match)) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "match-series-wrap" }, [
        _c("span", { staticClass: "match-num" }, [
          _vm._v(
            _vm._s(_vm.match.event_name ? _vm.match.event_name + ", " : "")
          ),
        ]),
        _c("span", { staticClass: "match-series" }, [
          _vm._v(_vm._s(_vm.match.series_name)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "match-data" }, [
        _c("div", { staticClass: "team team-A" }, [
          _c("span", { staticClass: "team-name" }, [
            _vm._v(_vm._s(_vm.match.teams[0].name)),
          ]),
          _c("span", { staticClass: "team-vs" }, [
            _vm._v(_vm._s(_vm.translations.vs_label)),
          ]),
          _c("span", { staticClass: "team-name team-B" }, [
            _vm._v(_vm._s(_vm.match.teams[1].name)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "match-more-info" }, [
        !_vm.hideMatchTips
          ? _c(
              "a",
              {
                staticClass: "match-info",
                attrs: {
                  href: _vm.getHref(
                    _vm.CFG_MODULES.MATCH_INFO.route,
                    _vm.match
                  ),
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.translations.match_info_label) +
                    "\n      "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "lineup-builder",
            attrs: {
              href: _vm.getHref(_vm.CFG_MODULES.LINEUP.route, _vm.match),
            },
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.translations.lineup_label) + "\n      "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "menu-card",
            attrs: {
              href: _vm.getHref(_vm.CFG_MODULES.GAME_PLAN.route, _vm.match),
            },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.translations.game_plan_label) +
                "\n      "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }